/**
 * The query string of the request params as axios 0.21 built it, kept after the axios upgrade (0.28+ writes nested
 * objects as `a[b]=1` instead of JSON, which the backend may not read). Rules: null / undefined values are skipped,
 * an array becomes `key[]=v` per item, a Date its ISO string, an object JSON; `: $ , [ ]` and spaces (`+`) stay
 * readable. Set as axios.defaults.paramsSerializer by utils/api/axios-defaults.
 */
const encode = (value: string) =>
    encodeURIComponent(value)
        .replace(/%3A/gi, ':')
        .replace(/%24/g, '$')
        .replace(/%2C/gi, ',')
        .replace(/%20/g, '+')
        .replace(/%5B/gi, '[')
        .replace(/%5D/gi, ']');

const serializeValue = (value: unknown) => {
    if (value instanceof Date) {
        return value.toISOString();
    }

    return value !== null && typeof value === 'object' ? JSON.stringify(value) : String(value);
};

export const serializeParams = (params: unknown): string => {
    if (params instanceof URLSearchParams) {
        return params.toString();
    }

    if (params === null || typeof params !== 'object') {
        return '';
    }

    return Object.entries(params as Record<string, unknown>)
        .filter(([, value]) => value !== null && value !== undefined)
        .flatMap(([key, value]) =>
            Array.isArray(value)
                ? value.map(item => `${encode(`${key}[]`)}=${encode(serializeValue(item))}`)
                : [`${encode(key)}=${encode(serializeValue(value))}`]
        )
        .join('&');
};
